import 'css-chunksrc/client/scenes/resourceEdition/form/roleSelection/styles.scss';export default {
  "roleSelection": "_roleSelection_1pqig_1",
  "input": "_input_1pqig_5",
  "selection": "_selection_1pqig_18",
  "placeholder": "_placeholder_1pqig_24",
  "list": "_list_1pqig_28",
  "role": "_role_1pqig_1",
  "iconBox": "_iconBox_1pqig_54",
  "icon": "_icon_1pqig_54",
  "opened": "_opened_1pqig_64",
  "selectedRole": "_selectedRole_1pqig_72",
  "selectedRoleIcon": "_selectedRoleIcon_1pqig_76",
  "selectedRoleTitle": "_selectedRoleTitle_1pqig_82",
  "roleDescription": "_roleDescription_1pqig_89"
};